fragment flexibleAccordion on flexibleSections_accordion_BlockType {
    __typename
    ... on flexibleSections_accordion_BlockType {
        id
        header: plaintext
        accordion {
            ... on accordionItem_Entry {
                id
                label
                richText
                prettyID: anchorId
            }
        }
    }
}
